"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clients = exports.singleServiceLineContext = exports.multipleServiceLineContext = exports.nullDisplayContext = exports.noContexts = exports.demoContext = exports.ssoContext = exports.cognitoContext = exports.allContexts = exports.overlappingContexts = exports.CU_Med = exports.ColoradoNullDisplay = exports.MockResources = void 0;
var user_1 = require("./user");
exports.MockResources = {
    search: {
        label: "Search",
        resourceName: "search",
        resourceId: 1,
        permissionLevel: "FULL_ACCESS",
        sequence: 1,
        type: "ui",
        parentId: null,
        serviceLines: ["*"],
        metadata: ""
    },
    orgs: {
        label: "Organizations",
        resourceName: "organizations",
        resourceId: 2,
        permissionLevel: "FULL_ACCESS",
        sequence: 2,
        type: "ui",
        parentId: null,
        serviceLines: ["*"],
        metadata: ""
    },
    users: {
        label: "Users",
        resourceName: "users",
        resourceId: 3,
        sequence: 3,
        permissionLevel: "FULL_ACCESS",
        type: "ui",
        parentId: null,
        serviceLines: ["*"],
        metadata: ""
    },
    assigning_authorities: {
        resourceId: 6,
        resourceName: "assigning_authorities",
        permissionLevel: "FULL_ACCESS",
        label: "Assigning Authorities",
        type: "ui",
        sequence: 5,
        parentId: null,
        serviceLines: ["*"],
        metadata: ""
    },
    dictionaries: {
        resourceId: 7,
        resourceName: "dictionary",
        permissionLevel: "FULL_ACCESS",
        label: "Dictionaries",
        type: "ui",
        sequence: 6,
        parentId: null,
        serviceLines: ["*"],
        metadata: ""
    }
};
var MDAnderson = {
    organizationId: 4,
    organizationCode: "MDA",
    organizationName: "MD Anderson Cancer Center",
    tenantId: "61494C60-DBAD-4C4E-B626-D6734D38357B",
    parentLevel: 1,
    organizationType: "HEALTH_SYSTEM",
    resources: [],
    displayName: "MD Anderson Cancer Center"
};
var CMX = {
    organizationId: 1,
    organizationName: "CodaMetrix",
    organizationCode: "CMX",
    organizationType: "BUSINESS",
    tenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
    parentLevel: 0,
    healthSystemTenantId: null,
    healthSystemCode: null,
    healthSystemName: null,
    resources: [],
    displayName: "CodaMetrix"
};
var Partners = {
    organizationId: 2,
    organizationCode: "PHS",
    organizationName: "Partners Health System",
    tenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
    parentLevel: 1,
    organizationType: "HEALTH_SYSTEM",
    resources: [],
    displayName: "Partners Health System"
};
var Colorado = {
    organizationId: 3,
    organizationCode: "Colorado",
    organizationName: "Colorado Health System",
    tenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
    parentLevel: 1,
    organizationType: "HEALTH_SYSTEM",
    resources: [],
    displayName: "Colorado Health System"
};
var AMCHealth = {
    organizationId: 5,
    organizationCode: "AMCH",
    organizationName: "AMC Health System",
    tenantId: "",
    parentLevel: 1,
    organizationType: "HEALTH_SYSTEM",
    resources: [],
    displayName: "AMC Health System",
    cognitoEnabled: true
};
var mockServiceLines = [
    {
        name: "Pathology",
        id: 2
    },
    {
        name: "Radiology",
        id: 1
    }
];
exports.ColoradoNullDisplay = {
    organizationId: 3,
    organizationCode: "Colorado",
    organizationName: "Colorado Health System",
    tenantId: "D84E98A4-D8E1-4294-BC61-C04F68E05992",
    parentLevel: 1,
    organizationType: "HEALTH_SYSTEM",
    resources: [],
    displayName: null
};
exports.CU_Med = {
    organizationId: 2,
    organizationCode: "UCH",
    organizationName: "University of Colorado Hospital",
    tenantId: "CUMEDID",
    organizationType: "Hospital",
    resources: [],
    displayName: "CU Medicine"
};
exports.overlappingContexts = {
    activeContextId: null,
    jwtToken: "",
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    user: user_1.MOCK_USER,
    contexts: [
        __assign(__assign({}, MDAnderson), { resources: [exports.MockResources.search], serviceLines: [] }),
        __assign(__assign({}, Partners), { resources: [exports.MockResources.users], serviceLines: [] }),
        __assign(__assign({}, Colorado), { resources: [exports.MockResources.users], serviceLines: [] })
    ]
};
exports.allContexts = {
    activeContextId: 4,
    jwtToken: "",
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    user: user_1.MOCK_USER,
    contexts: [
        __assign(__assign({}, MDAnderson), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: [] })
    ]
};
exports.cognitoContext = {
    activeContextId: 4,
    jwtToken: "",
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    user: user_1.MOCK_USER,
    contexts: [
        __assign(__assign({}, MDAnderson), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: [], cognitoEnabled: true })
    ]
};
exports.ssoContext = {
    activeContextId: 4,
    jwtToken: "",
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    user: user_1.MOCK_USER,
    contexts: [
        __assign(__assign({}, MDAnderson), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: [], ssoIndicator: true })
    ]
};
exports.demoContext = {
    activeContextId: 1,
    jwtToken: "",
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    user: user_1.DEMO_USER,
    contexts: [
        __assign(__assign({}, CMX), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: [] })
    ]
};
exports.noContexts = {
    activeContextId: null,
    jwtToken: "",
    user: user_1.MOCK_USER,
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    contexts: [
        __assign(__assign({}, MDAnderson), { resources: [], serviceLines: [] })
    ]
};
exports.nullDisplayContext = {
    activeContextId: 3,
    jwtToken: "",
    user: user_1.MOCK_USER,
    expiryDuration: 6000,
    expiryTimeToLive: 6000,
    contexts: [
        __assign(__assign({}, exports.ColoradoNullDisplay), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: [] })
    ]
};
exports.multipleServiceLineContext = __assign(__assign({}, exports.allContexts), { contexts: [
        __assign(__assign({}, MDAnderson), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: mockServiceLines })
    ] });
exports.singleServiceLineContext = __assign(__assign({}, exports.allContexts), { contexts: [
        __assign(__assign({}, MDAnderson), { resources: __spreadArray([], __read(Object.values(exports.MockResources)), false), serviceLines: [mockServiceLines[0]] })
    ] });
exports.Clients = { MDAnderson: MDAnderson, Partners: Partners, Colorado: Colorado };
//# sourceMappingURL=contexts.js.map